import Modal from '../helpers/Modal';

export default class PDFDownloadBlock {
    constructor(root) {
        this.root = root;
        this.open_buttons = this.root.querySelectorAll('.js-pdf-download-block-open');
        this.modal_root = document.querySelector('.js-pdf-viewer-modal');

        if(this.modal_root) {
            this.modal_iframe = this.modal_root.querySelector('.js-pdf-viewer-modal-iframe');
            this.modal_title = this.modal_root.querySelector('.js-pdf-viewer-modal-title');
            this.modal_download = this.modal_root.querySelector('.js-pdf-viewer-modal-download');

            this.modal = new Modal(this.modal_root, () => {
                this.modal_title.innerHTML = this.current_title;
                this.modal_download.setAttribute('href', this.current_url);
                this.modal_download.setAttribute('download', this.current_title);

                let new_iframe = document.createElement('iframe');
                new_iframe.classList.add('modal-pdf-viewer__iframe');
                new_iframe.setAttribute('src', this.current_url);

                this.modal_iframe.appendChild(new_iframe);
            },
            () => {
                this.modal_iframe.innerHTML = '';
                this.modal_title.innerHTML = '';
                this.modal_download.setAttribute('href', '#');
                this.modal_download.removeAttribute('download');
            });
        }

        this.open_buttons.forEach((open_button) => {
            open_button.addEventListener('click', (event) => {
                event.preventDefault();
                this.current_url = event.target.dataset.pdfUrl;
                this.current_title = event.target.dataset.pdfTitle;
                this.modal.open();
            });
        });
    }
}
